import type { RegistrantCatalogOption } from "./useRegistrantCatalogOptions";

type CatalogHandlers = {
  handleOrganizationChange: (option: RegistrantCatalogOption | null) => void;
  handleRegistrantChange: (option: RegistrantCatalogOption | null) => void;
};

export const editParticipantCatalogBridge: {
  handlers: CatalogHandlers | null;
} = {
  handlers: null,
};
